import React from 'react'

import Link from '@material-ui/core/Link'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED
} from 'api/actions'

const styles = theme => ({
  root: {
    padding: 16,
    paddingBottom: 0
  },
  rootTypography: {
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  shadewaysLogo: {
    paddingBottom: 10,
    width: 260
  }
})

class SearchPanelExternalLinks extends React.Component {
  preventDefault (event) { event.preventDefault() }

  render () {
    const { classes, expanded } = this.props

    if (!expanded) {
      return null
    }

    return <div className={classes.root} >
      <img className={classes.shadewaysLogo} src="./img/shadeways-logo.png" alt="shadeways-logo" />
      <Typography className={classes.rootTypography}>
        <Link target="_blank" href="https://data.pozi.com/bendigo/ShadewaysFlyer_fin_screen.pdf" >Instructions</Link>
      </Typography>

    </div>
  }
}

SearchPanelExternalLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired
}

function mapStateToProps (state, ownProps) {
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, true)
  return {
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanelExternalLinks)
  )
)
